import { jsx, jsxs } from "@emotion/react/jsx-runtime";
import { useTheme, css } from "@emotion/react";
import { useThemeProps, generateUniqueId, Card, parseStyle, CardContent, Heading, TypographyBlock, InlineList, Button, Section } from "@wsui/base";
import { useState, Fragment } from "react";
import { omit } from "lodash/fp";
CardBillboardModule.wsuiConfig = {
  hasCaption: false
};
function CardBillboardModule(props) {
  const theme = useTheme();
  props = useThemeProps({
    props,
    name: "MunicipioCardBillboardModule"
  });
  let {
    color,
    content,
    links,
    image,
    imagePlacement = "left",
    title,
    style,
    buttonMarginTop,
    horizontalContentMaxWidth,
    titleVariant = "h2",
    buttonProps,
    headingId,
    ...restProps
  } = omit(["imageAspectRatio", "align", "format"], props);
  const [defaltHeadingId] = useState(() => `module-heading-${generateUniqueId()}`);
  headingId = headingId || defaltHeadingId;
  let MaybeSection = title ? Section : Fragment;
  return /* @__PURE__ */jsx(Card, {
    color: color || "transparent",
    image,
    mirrored: imagePlacement === "right",
    css: /* @__PURE__ */css(parseStyle(style, theme), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:CardBillboardModule;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    horizontalContentMaxWidth,
    ...restProps,
    children: /* @__PURE__ */jsxs(CardContent, {
      rowGap: 2,
      children: [!!title && /* @__PURE__ */jsx(Heading, {
        variant: titleVariant,
        id: headingId,
        children: title
      }), /* @__PURE__ */jsx(MaybeSection, {
        children: /* @__PURE__ */jsx(TypographyBlock, {
          elementMapping: {
            p: "description"
          },
          marginAfter: true,
          children: content
        })
      }), !!(links == null ? void 0 : links.length) && /* @__PURE__ */jsx(InlineList, {
        children: links.map((_ref, index) => {
          let {
            link,
            variant = "primary"
          } = _ref;
          return /* @__PURE__ */jsx(Button, {
            ...link,
            variant,
            ...buttonProps
          }, index);
        })
      })]
    })
  });
}
export { CardBillboardModule as default };